import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";

export default function ReportOvertime() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    Promise.all([api.get("/attendance"), api.get("/employees")]).then(([a, e]) => {
      const emap = Object.fromEntries(e.data.map((x) => [x.id, x.nama]));
      const agg = {};
      a.data.forEach((r) => {
        const g = agg[r.employee_id] || { nama: emap[r.employee_id] || "-", hari: 0, lembur: 0 };
        if (r.status === "Hadir") g.hari += 1;
        g.lembur += Number(r.jam_lembur || 0);
        agg[r.employee_id] = g;
      });
      setRows(Object.values(agg).filter((g) => g.lembur > 0).sort((a, b) => b.lembur - a.lembur));
    });
  }, []);

  const columns = [
    { key: "nama", label: "Pegawai", sortable: true },
    { key: "hari", label: "Hari Masuk", align: "right", sortable: true },
    { key: "lembur", label: "Total Jam Lembur", align: "right", sortable: true, render: (r) => `${r.lembur} jam` },
  ];
  return (
    <div className="space-y-6">
      <PageHeader title="Laporan Lembur" subtitle="Rekap total jam lembur per pegawai" />
      <DataTable columns={columns} data={rows} searchKeys={["nama"]} testid="rep-ot-table" />
    </div>
  );
}
